<template>
  <div class="salary-data-mgr-container">
    <a-space direction="vertical" class="full-width">
      <a-card size="small">
        <a-row :gutter="12">
          <a-col :span="4">
            <div class="title">
              <span>工资数据管理</span>
            </div>
          </a-col>
          <a-col :span="20">
            <a-space style="float: right">
              <a-button type="primary" @click="search">查询</a-button>
              <a-button @click="resetFilters">重置</a-button>
              <a-button type="primary" @click="showImportModal">新增导入</a-button>
              <a-button>导出</a-button>
            </a-space>
          </a-col>
        </a-row>
      </a-card>

      <a-card size="small">
        <a-form :form="form" layout="horizontal" :wrapperCol="{span: 16}" :labelCol="{span: 6}">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="学部">
                <a-select v-model="searchForm.department" placeholder="请选择学部" allowClear>
                  <a-select-option value="小学部">小学部</a-select-option>
                  <a-select-option value="初中部">初中部</a-select-option>
                  <a-select-option value="高中部">高中部</a-select-option>
          
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="工资月份">
                <a-month-picker v-model="searchForm.salaryMonth" placeholder="请选择工资月份" style="width: 100%" value-format="YYYY-MM" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="导入状态">
                <a-select v-model="searchForm.importStatus" placeholder="请选择导入状态" allowClear>
                  <a-select-option :value="1">成功</a-select-option>
                  <a-select-option :value="0">失败</a-select-option>
                  <a-select-option :value="2">处理中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="发送状态">
                <a-select v-model="searchForm.sendStatus" placeholder="请选择发送状态" allowClear>
                  <a-select-option :value="1">已发送</a-select-option>
                  <a-select-option :value="0">未发送</a-select-option>
                  <a-select-option :value="2">发送中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-card>

      <a-card size="small">
        <a-table
          :columns="columns"
          :data-source="tableData"
          :pagination="pagination"
          :loading="loading"
          row-key="id"
          @change="handleTableChange"
        >
          <template slot="importStatus" slot-scope="text, record">
            <a-tag :color="getImportStatusColor(record.importStatus)">
              {{ getImportStatusText(record.importStatus) }}
            </a-tag>
          </template>
          <template slot="sendStatus" slot-scope="text, record">
            <a-tag :color="getSendStatusColor(record.sendStatus)">
              {{ getSendStatusText(record.sendStatus) }}
            </a-tag>
          </template>
          <template slot="filename" slot-scope="text, record">
            <div>
              <div>{{ record.mainFileName }}</div>
              <div>{{ record.detailFileName }}</div>
            </div>
          </template>
          <template slot="action" slot-scope="text, record">
            <a-space>
              <a-button type="primary"  href="javascript:;" @click="viewDetails(record)">查看详情</a-button>
              <a-button type="danger" danger :href="record.importStatus === 0 ? 'javascript:;' : 'javascript:;'"  v-if="record.importStatus === 1"
                 :class="{ 'disabled-link': record.importStatus === 0 }"
                 @click="record.importStatus === 0 ? null : sendRecord(record)">
                 {{ record.sendStatus==1?'重新发送':'一键发送' }}
                 
              </a-button>
              <a-button :href="record.importStatus === 1 ? 'javascript:;' : 'javascript:;'"  v-if="record.importStatus === 0"
                 :class="{ 'disabled-link': record.importStatus === 1 }"
                 @click="record.importStatus === 1 ? null : downloadFeedback(record)">
                下载反馈
              </a-button>
              <!-- <a :href="record.importStatus === 0 ? 'javascript:;' : 'javascript:;'" 
                 :class="{ 'disabled-link': record.importStatus === 0 }"
                 @click="record.importStatus === 0 ? null : resendRecord(record)">
                重新发送
              </a> -->
            </a-space>
          </template>
          <template slot="importTime" slot-scope="text">
            {{ text ? new Date(text).toLocaleString('zh-CN', {year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit'}) : '' }}
          </template>
        </a-table>
      </a-card>
    </a-space>

    <!-- 导入模态框 -->
    <salary-import-modal
      :visible="importModalVisible"
      @cancel="handleImportModalCancel"
      @import-success="handleImportSuccess"
    />
    
    <!-- 详情模态框 -->
    <salary-import-detail-modal
      :visible="detailModalVisible"
      :record="currentRecord"
      @cancel="handleDetailModalCancel"
    />
    
    <!-- 发送工资条模态框 -->
    <salary-send-modal
      :visible="sendModalVisible"
      :record="currentSendRecord"
      @confirm-send="handleConfirmSend"
      @cancel="handleSendModalCancel"
    />
  </div>
</template>

<script>
import { getSalaryImportRecordList, sendSalaryNotice } from '@/services/salary'
import { downloadFile } from '@/services/system'
import SalaryImportModal from '@/components/SalaryImportModal.vue'
import SalaryImportDetailModal from '@/components/SalaryImportDetailModal.vue'
import SalarySendModal from '@/components/SalarySendModal.vue'

export default {
  components: {
    SalaryImportModal,
    SalaryImportDetailModal,
    SalarySendModal
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        department: '',
        salaryMonth: null,
        importStatus: null,
        sendStatus: null
      },
      // 分页配置
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        pageSizeOptions: ['10', '20', '50', '100']
      },
      // 表格数据
      tableData: [],
      loading: false,
      // 导入模态框显示状态
      importModalVisible: false,
      // 详情模态框显示状态
      detailModalVisible: false,
      // 当前查看的记录
      currentRecord: {},
      // 发送工资条模态框显示状态
      sendModalVisible: false,
      // 当前操作的记录
      currentSendRecord: {},
      // 定义表格列配置
      columns: [
        {
          title: '学部',
          dataIndex: 'department',
          key: 'department'
        },
        {
          title: '工资月份',
          dataIndex: 'salaryMonth',
          key: 'salaryMonth'
        },
        {
          title: '工资标题',
          dataIndex: 'salaryTitle',
          key: 'salaryTitle'
        },
        {
          title: '导入人',
          dataIndex: 'importUserName',
          key: 'importUserName'
        },
        {
          title: '导入时间',
          dataIndex: 'importTime',
          key: 'importTime',
          scopedSlots: { customRender: 'importTime' }
        },
        {
          title: '文件名称',
          dataIndex: 'filename',
          key: 'filename',
          scopedSlots: { customRender: 'filename' }
        },
        {
          title: '记录数',
          dataIndex: 'recordCount',
          key: 'recordCount'
        },
        {
          title: '导入状态',
          dataIndex: 'importStatus',
          key: 'importStatus',
          scopedSlots: { customRender: 'importStatus' }
        },
        {
          title: '发送状态',
          dataIndex: 'sendStatus',
          key: 'sendStatus',
          scopedSlots: { customRender: 'sendStatus' }
        },
        {
          title: '操作',
          key: 'action',
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  mounted() {
    this.search()
  },
  methods: {
    async search() {
      this.loading = true
      try {
        const params = {
          ...this.searchForm,
          salaryMonth: this.searchForm.salaryMonth,
          pageNum: this.pagination.current,
          pageSize: this.pagination.pageSize
        }
        const response = await getSalaryImportRecordList(params)
        if (response.data.code === 200) {
          this.tableData = response.data.data.records || []
          this.pagination.total = response.data.data.total || 0
        }
      } catch (error) {
        console.error('获取工资导入记录失败:', error)
      } finally {
        this.loading = false
      }
    },
    resetFilters() {
      this.searchForm.department = ''
      this.searchForm.salaryMonth = null
      this.searchForm.importStatus = null
      this.searchForm.sendStatus = null
      this.searchForm.filename = ''
      this.pagination.current = 1
      this.search()
    },
    handleTableChange(pag) {
      this.pagination = { ...this.pagination, ...pag }
      this.search()
    },
    viewDetails(record) {
      this.currentRecord = record
      this.detailModalVisible = true
    },
    async sendRecord(record) {
      // 检查导入状态，如果是失败则不执行操作
      if (record.importStatus === 0) {
        this.$message.warning('无法发送失败的导入记录，请先解决导入问题');
        return;
      }
      // 显示发送工资条模态框
      this.showSendModal(record);
    },
    async downloadFeedback(record) {
      // 检查导入状态，如果是成功则不执行操作
      if (record.importStatus === 1) {
        this.$message.warning('导入成功的记录无需下载反馈文件');
        return;
      }
      
      // 检查是否有错误校验保存路径
      if (!record.errorFilePath) {
        this.$message.warning('没有找到错误校验文件');
        return;
      }
      
      try {
        const params = {
          relativePath: record.errorFilePath
        };
         
        await downloadFile(params);
        this.$message.success('错误校验文件下载成功');
      } catch (error) {
        console.error('下载错误校验文件失败:', error);
        this.$message.error('下载错误校验文件失败');
      }
    },
    resendRecord(record) {
      // 检查导入状态，如果是失败则不执行操作
      if (record.importStatus === 0) {
        this.$message.warning('无法重新发送失败的导入记录，请先解决导入问题');
        return;
      }
      console.log('重新发送记录:', record)
      // 重新发送逻辑
    },
    getImportStatusText(status) {
      switch (status) {
        case 0: return '失败'
        case 1: return '成功'
        case 2: return '处理中'
        default: return '未知'
      }
    },
    getImportStatusColor(status) {
      switch (status) {
        case 0: return 'red'
        case 1: return 'green'
        case 2: return 'orange'
        default: return 'gray'
      }
    },
    getSendStatusText(status) {
      switch (status) {
        case 0: return '未发送'
        case 1: return '已发送'
        case 2: return '发送中'
        default: return '未知'
      }
    },
    getSendStatusColor(status) {
      switch (status) {
        case 0: return 'orange'
        case 1: return 'blue'
        case 2: return 'gold'
        default: return 'gray'
      }
    },
    showImportModal() {
      this.importModalVisible = true
    },
    handleImportModalCancel() {
      this.importModalVisible = false
    },
    handleImportSuccess() {
      this.importModalVisible = false
      // 刷新数据列表
      this.search()
    },
    handleDetailModalCancel() {
      this.detailModalVisible = false
    },
    
    // 显示发送工资条模态框
    showSendModal(record) {
      this.currentSendRecord = record;
      this.sendModalVisible = true;
    },
    
    // 处理发送工资条确认
    async handleConfirmSend(params) {
      try {
        // 调用服务端发送接口
        const response = await sendSalaryNotice(params);
        if (response.data.code === 200) {
          this.$message.success(response.data.message || '工资条发送成功');
          // 刷新当前列表
          this.search();
        } else {
          this.$message.error(response.data.message || '工资条发送失败');
        }
      } catch (error) {
        console.error('发送工资条失败:', error);
        this.$message.error('发送工资条失败，请稍后重试');
      }
    },
    
    // 处理发送模态框取消
    handleSendModalCancel() {
      this.sendModalVisible = false;
      this.currentSendRecord = {};
    }
  }
}
</script>

<style lang='less' scoped>
.full-width {
  width: 100%;
}

.title {
  text-align: left;
  height: 30px;
  line-height: 30px;

  span {
    font-size: 18px;
    font-weight: bold;
  }
}

.table-toolbar {
  margin-bottom: 16px;
}

.disabled-link {
  pointer-events: none;
  color: #ccc !important;
  cursor: not-allowed;
}
</style>